<template>
  <div class="measurementTracker">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg">
          <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
            <h5 class="txt-dark trackerMeasurements">Measurements Tracker</h5>
          </div>
          <div class="pull-right">
            <a
              href="#"
              data-toggle="modal"
              data-target="#measurementsTrackingModal"
              ref="trackWeightModalTrigger"
              class="btn btn-nutri-green"
              style="margin-right:15px;"
            >Track Measurements</a>
          </div>
        </div>
        <!-- /Title -->
        <div class="panel panel-default card-view panel-refresh">
          <div class="panel-heading">
            <div class="pull-left">
              <h6 class="panel-title txt-light">Measurements Progress</h6>
            </div>
            <div class="clearfix"></div>
          </div>
          <div id="collapse_1" class="panel-wrapper collapse in">
            <div class="panel-body">
              <div class="col-sm-12">
                <div
                  class="text-center"
                  v-show="Object.keys(progress_records).length == 0"
                >There are no records to show.</div>

                <div class="table-wrap" v-show="Object.keys(progress_records).length > 0">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th style="width:20%;">Photo</th>
                          <th>Date</th>
                          <th>Neck</th>
                          <th>Biceps</th>
                          <th>Chest</th>
                          <th>Waist</th>
                          <th>Hips</th>
                          <th>Tigh</th>
                          <th>Calf</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in progress_records" v-bind:key="index">
                          <td>
                            <div
                              type="button"
                              @click="pictureModal(record.photo)"
                              class="btn btn-light mainphoto"
                              data-toggle="modal"
                              data-target="#ModalCenter"
                            >
                              <img
                                :src="record.photo ? record.photo : 'dist/img/nophoto.jpg'"
                                alt="photo"
                              >
                            </div>
                            <!-- Modal -->
                            <div
                              class="modal fade"
                              id="ModalCenter"
                              tabindex="-1"
                              role="dialog"
                              aria-labelledby="ModalCenterTitle"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <img
                                      style="height:100% !important;max-height:400px;"
                                      :src="modal_picture ? modal_picture : 'dist/img/nophoto.jpg'"
                                      alt="photo"
                                    >
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      type="button"
                                      class="btn btn-nutri-red"
                                      data-dismiss="modal"
                                    >Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>{{index}}</td>
                          <td>{{record.Neck}}</td>
                          <td>{{record.Biceps}}</td>
                          <td>{{record.Chest}}</td>
                          <td>{{record.Waist}}</td>
                          <td>{{record.Hips}}</td>
                          <td>{{record.Tigh}}</td>
                          <td>{{record.Calf}}</td>
                          <td>
                            <a
                              href="#"
                              class="trash"
                              title="Delete"
                              data-toggle="modal"
                              @click="temp_id = index"
                              data-target="#exampleModal"
                            >
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Content -->
      <AppFooter></AppFooter>
    </div>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
          </div>
          <div class="modal-body">Are you sure you want to delete this measurement record?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-nutri-green"
              data-dismiss="modal"
              @click="deleteRecord(temp_id)"
            >Okay</button>
          </div>
        </div>
      </div>
    </div>

    <!--measurementsTrackingModal-->
    <!-- Weight Tracking Modal -->
    <div
      id="measurementsTrackingModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width:1000px;">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header-icon">
              <img src="dist/img/icons/measurements.png" alt="measurements">
              <h4>Track your measurements</h4>
							<br/>
							<br/>
              <div class="col-md-4">
								<img :src="'https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/measurements/' + $store.getters.user.meta_data.gender + (measurement_focus ? '_' + measurement_focus : '') + '.png'" alt="" style="height: 500px;">
							</div>
							<div class="col-md-8">
								<form class="form-horizontal">
									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Date</label>
										<div class="col-sm-9">
											<div class="input-group col-sm-12">
												<datepicker inputClass="form-control" v-model="newMeasurementDate"></datepicker>
                        <!-- <datetime v-model="newMeasurementDate" input-id="startDate">
                          <template slot="button-cancel">
                            <fa :icon="['far', 'times']"></fa>
                            Cancel
                          </template>
                          <template slot="button-confirm">
                            <fa :icon="['fas', 'check-circle']"></fa>
                            Confirm
                          </template>
                        </datetime> -->
											</div>
										</div>
									</div>
									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Neck</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="neck" v-model="newNeckValue" @focus="measurement_focus = 'neck';">
											</div>
										</div>
										<label for="name" class="col-sm-3 control-label">Biceps</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="arm" v-model="newUpperArmValue"  @focus="measurement_focus = 'upper_arm';">
											</div>
										</div>
									</div>

									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Chest</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input
													type="number"
													class="form-control"
													id="chest"
													v-model="newChestArmValue"
													@focus="measurement_focus = 'chest';"
												>
											</div>
										</div>
										<label for="name" class="col-sm-3 control-label">Waist</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="waist" v-model="newWaistValue" @focus="measurement_focus = 'waist';">
											</div>
										</div>
									</div>

									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Hips</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="hips" v-model="newHipsValue" @focus="measurement_focus = 'hips';">
											</div>
										</div>
										<label for="name" class="col-sm-3 control-label">Thigh</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="thigh" v-model="newTighValue" @focus="measurement_focus = 'thigh';">
											</div>
										</div>
									</div>

									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Calf</label>
										<div class="col-sm-3">
											<div class="input-group col-sm-12">
												<input type="number" class="form-control" id="calf" v-model="newCalfValue" @focus="measurement_focus = 'calf';">
											</div>
										</div>
									</div>
									<div class="form-group">
										<label for="name" class="col-sm-3 control-label">Progress Photo</label>
										<div class="col-sm-9">
											<div class="input-group col-sm-12">
												<button
													type="button"
													@click="$refs.file.click()"
													class="btn btn-block btn-nutri-green"
												>Upload Picture</button>
												<input
													v-show="false"
													type="file"
													id="file"
													ref="file"
													v-on:change="handleFileUpload()"
												>
											</div>
										</div>
                    <div class="col-sm-3" style="padding-top:20px;">
										</div>
										<div class="col-sm-9" style="padding-top:20px;">
											<img :src="photo_url" v-if="photo_url" alt>
										</div>
									</div>
								</form>
							</div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-nutri-red"
              data-dismiss="modal"
              ref="measurementTrackerClose"
            >Close</button>
            <button
              type="button"
              class="btn btn-nutri-green"
              ref="measurementTrackerTrack"
              data-dismiss="modal"
              @click="addWeight"
            >Track</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
      <!-- /.modal -->
    </div>
    <loading :active.sync="isLoading"></loading>
  </div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter.vue";
import WeightProgressChart from "../../components/common/WeightProgressChart.vue";
import WeightStatusWidget from "../../components/common/WeightStatusWidget.vue";
import Datepicker from "vuejs-datepicker";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapMutations } from "vuex";
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
const api = new API();

export default {
  components: {
    AppHeader,
    AppFooter,
    WeightProgressChart,
    WeightStatusWidget,
    Datepicker,
    swal,
    Loading,
    Datetime,
  },
  props: ["date"],
  data() {
    return {
      isLoading: false,
      progress_records: [],
      newMeasurementDate: new Date(),
      newMeasurementPhoto: "",
      newNeckValue: null,
      newUpperArmValue: null,
      newChestArmValue: null,
      newWaistValue: null,
      newHipsValue: null,
      newTighValue: null,
      newCalfValue: null,
      photo_url: null,
      modal_picture: "",
			temp_id: 0,
			measurement_focus: null
    };
  },
  created() {
    this.loadProgress();
  },
  mounted() {},
  watch: {
    date: function() {
      this.refreshComponents();
    }
  },
  methods: {
    refreshComponents() {
      this.progress_records = [];
      this.loadProgress();

      this.newMeasurementPhoto = null;
      this.newNeckValue = null;
      this.newUpperArmValue = null;
      this.newChestArmValue = null;
      this.newWaistValue = null;
      this.newHipsValue = null;
      this.newTighValue = null;
      this.newCalfValue = null;
    },
    deleteRecord(date) {
      this.isLoading = true;
      api.deleteMeasurements(date).then(async response => {
        this.isLoading = false;
        swal("Measurement Records Deleted!", "", "success");
        this.refreshComponents();
      });
    },
    addWeight() {
      this.isLoading = true;
      api
        .addMeasurements(
          [
            { Name: "Neck", Value: this.newNeckValue },
            { Name: "Biceps", Value: this.newUpperArmValue },
            { Name: "Chest", Value: this.newChestArmValue },
            { Name: "Waist", Value: this.newWaistValue },
            { Name: "Hips", Value: this.newHipsValue },
            { Name: "Tigh", Value: this.newTighValue },
            { Name: "Calf", Value: this.newCalfValue }
          ],
          this.newMeasurementDate,
          this.photo_url
        )
        .then(async response => {
          this.isLoading = false;
          const elem = this.$refs.measurementTrackerClose;
          elem.click();
          this.photo_url = "";
          swal("Measurements Tracked!", "", "success");
          this.refreshComponents();
        });
    },
    handleFileUpload() {
      this.photo_url = null;
      const elem = this.$refs.measurementTrackerClose;
      const elem2 = this.$refs.measurementTrackerTrack;

      elem.disabled = true;
      elem2.disabled = true;

      api
        .uploadPhoto("progress", this.$refs.file.files[0])
        .then(async response => {
          if (response.data.success) {
            this.photo_url = response.data.data;
            elem.disabled = false;
            elem2.disabled = false;
          }
        });
    },
    loadProgress() {
      api.getProgress().then(response => {
        if (response.data.success) {
          this.progress_records = response.data.data;
        }
      });
    },
    pictureModal(picture) {
      this.modal_picture = picture;
    }
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

/* table th{
	font-weight: bold;
	text-align:center;
	padding: 15px;
	background: #ddd;
}

table td{
	text-align:center;
	padding: 15px;
	vertical-align: top;
	border: 1px solid #ccc;
} */

table td,
table th {
  text-align: center;
}
table td img {
  height: 100px;
}

.widget {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

.trash {
  color: rgba(204, 0, 0, 0.5);
}

.trash:hover {
  color: rgba(204, 0, 0, 1);
}

.trackerMeasurements {
  margin-left: 14px;
}

label {
  text-align: left;
}
.table-wrap {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.mainphoto {
  padding: 0;
}

#ModalCenter {
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/views/MeasurementsTracking/MeasurementsTracking.vue